import { helpers } from 'vuelidate/lib/validators'

export default fileType =>
  helpers.withParams(
    { type: 'fileType', fileType: fileType },
    function(value, parentVm) {
        if (!value) {
            return true
        } else {
            const allowed = ['application/pdf','image/jpeg']
            var type = value.type
            var start = type.substring(0, (type.indexOf('/')))
            return (allowed.indexOf(type) > -1)
        }
    }
  )